var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('router-view',{attrs:{"downloads":_vm.downloads,"postdata":_vm.postdata,"aboutdata":_vm.about_data,"referbuildings":_vm.refer_buildings,"referfirms":_vm.refer_firms}}),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }